import { render, staticRenderFns } from "./protectList.vue?vue&type=template&id=68833edc&scoped=true&"
import script from "./protectList.vue?vue&type=script&lang=js&"
export * from "./protectList.vue?vue&type=script&lang=js&"
import style0 from "./protectList.vue?vue&type=style&index=0&id=68833edc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68833edc",
  null
  
)

export default component.exports